module.exports = __webpack_public_path__ + "static/media/11.305b5dcf.jpg";